<template>
  <i class="icon" :class="`icon-${name}`" />
</template>

<script>
export default {
  props: ["name"],
}
</script>
